var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0471822 9.62718L6.78717 16.3672C6.81304 16.3911 6.84696 16.4043 6.88217 16.4043C6.91739 16.4043 6.95131 16.3911 6.97717 16.3672L13.7172 9.62718C13.734 9.60724 13.7449 9.583 13.7486 9.5572C13.7524 9.53141 13.7489 9.50509 13.7385 9.48119C13.7281 9.45728 13.7112 9.43673 13.6898 9.42189C13.6684 9.40705 13.6432 9.39849 13.6172 9.39717H0.137179C0.109847 9.39566 0.0827509 9.40282 0.0597249 9.41762C0.036699 9.43242 0.0189183 9.45411 0.00894369 9.4796C-0.00103093 9.50509 -0.00271296 9.53309 0.00415243 9.55959C0.0110178 9.58608 0.0260845 9.60974 0.0471822 9.62718Z",
    fill: "#C0C0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7172 6.77716L6.97717 0.0371704C6.95131 0.0132754 6.91739 0 6.88217 0C6.84696 0 6.81304 0.0132754 6.78717 0.0371704L0.0471822 6.77716C0.0260845 6.7946 0.0110178 6.81826 0.00415243 6.84476C-0.00271296 6.87125 -0.00103093 6.89925 0.00894369 6.92474C0.0189183 6.95023 0.036699 6.97192 0.0597249 6.98672C0.0827509 7.00153 0.109847 7.00868 0.137179 7.00717H13.6172C13.6432 7.00585 13.6684 6.99729 13.6898 6.98245C13.7112 6.96761 13.7281 6.94706 13.7385 6.92316C13.7489 6.89925 13.7524 6.87293 13.7486 6.84714C13.7449 6.82134 13.734 6.7971 13.7172 6.77716Z",
    fill: "#C0C0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortInactive);
export default __webpack_public_path__ + "static/media/sortInactive.cd1b94b66dab7e68c2991dc56433664d.svg";
export { ForwardRef as ReactComponent };